import { settings } from '@/api/config';
import axios from 'axios';
import { getInitData } from '@/utils/getInitData';
import { useNotificationStore } from '../../../store/NotificationStore';

export function loginUser() {
  const tg = window?.Telegram?.WebApp;
  const encodedInitData = encodeURIComponent(getInitData());

  // @ts-ignore - allows_write_to_pm exists in Telegram WebApp API but not in type definitions
  const isBlocked = tg?.initDataUnsafe?.user?.allows_write_to_pm;
  console.log('isBlocked:', isBlocked);
  // @ts-ignore - start_param exists in Telegram WebApp API but not in type definitions
  const startParam = tg?.initDataUnsafe?.start_param || null;
  // const encodedInitData = tg?.initData;

  console.log('initData:', getInitData());
  console.log('initDataUnsafe:', tg?.initDataUnsafe);
  console.log('WebApp:', tg);
  return axios
    .post(
      `${settings.url}api/users/login/${startParam}?initData=${encodedInitData}`,
    )
    .then(async (response) => {
      console.log('IsPass', response.data);

      try {
        return {
          data: response.data,
          startup_code: startParam,
          onb_pass: response.data.data.passed,
        };
      } catch (onbErr) {
        console.error('[loginUser] onb.pass error:', onbErr);
      }
    })
    .catch((error) => {
      console.error('[loginUser] Error:', error);
      throw error;
    });
}

export function checkWriteAccessOnLoad(): Promise<'blocked' | void> {
  const tg = window?.Telegram?.WebApp;

  // Рекурсивная функция для запроса доступа
  const requestAccess = (): Promise<'blocked' | void> => {
    // Проверяем текущий статус доступа
    // @ts-ignore - allows_write_to_pm exists in Telegram WebApp API but not in type definitions
    const allows = tg?.initDataUnsafe?.user?.allows_write_to_pm;
    console.log('allowss:', allows);

    // Если доступ уже предоставлен, завершаем
    if (allows === true) {
      return Promise.resolve();
    }

    // Запрашиваем доступ (независимо от того, false или undefined)
    return new Promise<'blocked' | void>((resolve) => {
      // @ts-ignore — в типах TG это не описано
      tg?.requestWriteAccess((granted: boolean) => {
        if (granted) {
          resolve();
        } else {
          requestAccess().then(resolve);
        }
      });
    });
  };

  return requestAccess();
}

export function getBonus(): Promise<'blocked' | void> {
  const tg = window?.Telegram?.WebApp;
  const allows = tg?.initDataUnsafe?.user?.allows_write_to_pm;
  console.log('allowss:', allows);
  const encodedInitData = encodeURIComponent(getInitData());

  const sendBonus = async () => {
    await axios.post(
      `${settings.url}api/users/bonus?initData=${encodedInitData}`,
    );
  };

  // Уже знаем, что доступ есть
  if (allows === true) {
    return sendBonus();
  }

  // Уже знаем, что доступ запрещён
  if (allows === false) {
    return Promise.resolve<'blocked'>('blocked');
  }

  // allows === undefined → нужно запросить доступ
  return new Promise<'blocked' | void>((resolve) => {
    // @ts-ignore — в типах TG это не описано
    tg?.requestWriteAccess(async (granted: boolean) => {
      if (granted) {
        try {
          await sendBonus();
        } catch (err) {
          console.error('[getBonus] Error:', err);
        }
        resolve();
      } else {
        resolve('blocked');
      }
    });
  });
}

export async function getReward() {
  const tg = window?.Telegram?.WebApp;
  if (!tg?.initData) {
    throw new Error('Telegram WebApp не инициализирован');
  }

  try {
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.get(
      `${settings.url}api/users/rewards?initData=${encodedInitData}`,
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при получении баланса:', error);
    throw error;
  }
}

export async function claimReward(reward_id: number) {
  const tg = window?.Telegram?.WebApp;
  if (!tg?.initData) {
    throw new Error('Telegram WebApp не инициализирован');
  }

  try {
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.post(
      `${settings.url}api/users/rewards/claim/${reward_id}?initData=${encodedInitData}`,
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при получении баланса:', error);
    throw error;
  }
}
